import { render, staticRenderFns } from "./CargoOrders.vue?vue&type=template&id=503e310d&"
import script from "./CargoOrders.vue?vue&type=script&lang=js&"
export * from "./CargoOrders.vue?vue&type=script&lang=js&"
import style0 from "./CargoOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports